export enum VisitPlanScheduleStatusEnum {
  PLANNED = "PLANNED",
  NOT_PLANNED = "NOT_PLANNED"
}


export const VisitPlanScheduleStatusColorMap: Record<VisitPlanScheduleStatusEnum, string> = {
  [VisitPlanScheduleStatusEnum.NOT_PLANNED]: '#E4EEFB',
  [VisitPlanScheduleStatusEnum.PLANNED]: '#FFF8E0'
};
